import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IPopupData } from '../../interfaces/popup-data.interface';

@Component({
    selector: 'aumico-information-popup',
    templateUrl: 'information-popup.component.html',
    styleUrls: ['information-popup.component.scss'],
})
export class AumicoInformationPopupComponent {
    isContentHtmlType: boolean | undefined;
    contentMessage: string | undefined;
    titleLocalizationKey = 'aumico_core_information_popup_default_title';

    constructor(
        private dialogRef: MatDialogRef<AumicoInformationPopupComponent, void>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) private popupData: IPopupData,
    ) {
        if (this.popupData.contentMessage != null) {
            this.contentMessage = this.popupData.contentMessage;
        }

        if (this.popupData.titleLocalizationKey != null) {
            this.titleLocalizationKey = this.popupData.titleLocalizationKey;
        }

        this.isContentHtmlType = this.popupData.isContentHtmlType;

        this.addSvgIcon('interface-delete 1');
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
